import axios, {AxiosResponse} from "axios";
import {Client, CreateClient} from "../types/types";
import {UseToast} from "../hooks/useToast";
import {ExportExcelParams} from "react-ive-tables/dist/ReactiveTable";

export class ClientService {
    private readonly url: string;
    private readonly toastHelpers : Pick<UseToast, 'showDeletedToast' | 'showUpdatedToast' | 'showCreatedToast' | 'showToast'>
    private readonly f : any;

    constructor(f: any, toastHelpers  : Pick<UseToast, 'showDeletedToast' | 'showUpdatedToast' | 'showCreatedToast' | 'showToast'> ) {
        this.toastHelpers = toastHelpers;
        this.f = f;
        this.url = '/clients';
        this.uploadClientFile = this.uploadClientFile.bind(this);
        this.downloadClientFile = this.downloadClientFile.bind(this);
        this.deleteClientFile = this.deleteClientFile.bind(this);
    }

    async create(client: CreateClient){
        return new Promise<Client>((resolve, reject) => {
            const bankAccounts = client.bankAccount?.map(el => el.toUpperCase()).join(",");
            const parsedData = {...client, bankAccount: bankAccounts};
            axios.post<Client>(this.url, parsedData).then(response => {
                resolve(response.data)
                this.toastHelpers.showCreatedToast(this.f, this.f({id: 'theClient'}),'', true);
            }).catch(error => {
                if(error.response.status === 409){
                    const message = error.response.data.message;
                    if(message){
                        this.toastHelpers.showToast('warn', this.f({id: 'operationUnsuccessful'}), this.f({id: message}))
                    }
                }else{
                    this.toastHelpers.showCreatedToast(this.f, this.f({id: 'theClient'}),'', false);
                }
                reject(error);
            })
        })
    }

    async update(client: CreateClient){
        return new Promise<Client>((resolve, reject) => {
            const bankAccounts = client.bankAccount?.map(el => el.toUpperCase()).join(",");
            const parsedData = {...client, bankAccount: bankAccounts};
            axios.put<Client>(this.url, parsedData).then(response => {
                resolve(response.data)
                this.toastHelpers.showUpdatedToast(this.f, this.f({id: 'theClient'}),'', true);
            }).catch(error => {
                if(error.response.status === 409){
                    const message = error.response.data.message;
                    if(message){
                        this.toastHelpers.showToast('warn', this.f({id: 'operationUnsuccessful'}), this.f({id: message}))
                    }
                }else{
                    this.toastHelpers.showUpdatedToast(this.f, this.f({id: 'theClient'}),'', false);
                }
                reject(error);
            })
        })
    }

    async delete(clientId : number){
        return new Promise<boolean>((resolve, reject) => {
            axios.delete<boolean>(this.url + '/' + clientId).then(response => {
                resolve(response.data)
                this.toastHelpers.showDeletedToast(this.f, this.f({id: 'theClient'}),'', true);
            }).catch(error => {
                reject(error);
                this.toastHelpers.showDeletedToast(this.f, this.f({id: 'theClient'}),'', false);
            })
        })
    }

    async uploadClientFile(file: any, clientId: number) {
        let formData = new FormData();
        formData.append("file", file);
        const headers = { 'Content-Type': 'multipart/form-data' };
        return new Promise<any>((resolve, reject) => {
            axios.post(this.url + "/clientFiles/" + clientId, formData, { headers }).then(response => {
                resolve(response);
            })
        })
    }

    async deleteClientFile(fileId: number) {
        return new Promise<boolean>((resolve, reject) => {
            axios.delete<boolean>(this.url + "/clientFiles/" + fileId).then(response => {
                resolve(response.data)
            })
        })
    }

    async downloadClientFile(fileId: number) {
        return new Promise<any>((resolve, reject) => {
            axios.get(this.url + "/clientFiles/" + fileId, { responseType: 'arraybuffer' }).then(response => {
                const blob = new Blob([response.data], {
                    type: response.headers['content-type'],
                });
                resolve(blob);
            }).catch(reject);
        })
    }

    async exportExcel(params: Omit<ExportExcelParams, "sort"> & {order?: Record<string,string>}) {
        return new Promise<AxiosResponse<BlobPart>>((resolve, reject) => {
            axios.post<BlobPart>(this.url + "/generateExcel", params, {responseType: 'arraybuffer'} ).then(response => {
                resolve(response)
            }).catch(err => reject(err))
        })
    }

    async addIbanToClient(clientId: number, iban: string) {
        return new Promise<boolean>((resolve, reject) => {
            axios.put<boolean>(this.url + `/${clientId}/iban/${iban}`, {} ).then(response => {
                resolve(response.data)
            }).catch(err => reject(err))
        })
    }




}
